import { api, ApiError } from "@/api/api";
import { ImageDetails } from "@/api/images-types";
import { useQuery } from "@tanstack/react-query";

export function useImageById(id: string | undefined) {
  return useQuery<ImageDetails, ApiError>({
    queryKey: ["GET", "images", id],
    queryFn: () => api.images.imageId.get({ imageId: id! }),
    enabled: !!id,
  });
}
